export const PREFIXES_BY_COUNTRY = {
    "ES": "+34",
    "FR": "+33",
    "IT": "+39",
    "CH": "+41",
    "BE": "+32",
    "LU": "+352",
};
